<template>
  <!-- 联系人方式 -->
  <div id="enterprise-card3">
    <div class="enterprise-card3-list">
      <div
        class="enterprise-card3-item"
        v-for="(item, index) in information.tableData"
        :key="index"
      >
        <div class="title">
          <div>
            <span class="title-name">{{ item.name || "--" }}</span>
            <span class="title-position">{{ item.position }}</span>
          </div>
        </div>
        <div class="phone">
          <div>
            <i
              class="icon el-icon-phone-outline"
              style="color: red;"
              @click="callNumber(item.phone)"
            ></i>
          </div>
          <div class="phone-number" @copy="onCopy(item)">
            {{ showPhone(item) }}
          </div>
          <div>
            <i
              v-if="!showPhoneFlag && viewContactFlag"
              class="iconfont icon-eye-close icon"
              @click="changeShowPhoneFlag(item)"
            ></i>
            <i
              v-if="showPhoneFlag && viewContactFlag"
              class="iconfont icon-eye-open icon"
              @click="changeShowPhoneFlag(item)"
            ></i>
          </div>
          <div class="active"></div>
          <div>
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              plain
              size="mini"
              v-if="viewContactFlag"
              @click="handleClick(item, index, 'edit')"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              plain
              size="mini"
              v-showFunction="{
                active: 'deleteContact',
                array: allFunctionButtons,
              }"
              @click="handleClick(item, index, 'delete')"
            ></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    information: {
      type: Object,
      default: () => {},
    },
    allFunctionButtons: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      baseInfo: {},
      viewContactFlag: false,
      showPhoneFlag: false,
    };
  },
  methods: {
    /**
     * 判断给定参数用户是否可以显示客户联系人
     */
    showContactsOrNot() {
      let requestData = {
        userId: this.baseInfo.userId,
        companyId: this.baseInfo.company.companyId,
        clientId: this.clientInfo.id,
      };
      this.$request(
        "post",
        "/client/editContactsOrNot",
        requestData,
        (data) => {
          if (data) {
            this.viewContactFlag = true;
          } else {
            this.viewContactFlag = false;
          }
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 拨打电话 好销云
     */
    callNumber: _.throttle(function(phone) {
      let requestData = {
        userId: this.baseInfo.userId, // 操作人
        TelB: phone, // 被叫号码号码
        Accessional: {
          clientId: this.clientInfo.id,
          userId: this.baseInfo.userId, // 操作人 id
          icon: this.baseInfo.img, // 操作人图标
          name: this.baseInfo.userName, // 操作人名称
          handleType: "addFollowRecord", // 操作类型 呼叫
        },
      };
      requestData.Accessional = JSON.stringify(requestData.Accessional);
      this.$request(
        "post",
        "/haoXiaoYun/bind",
        requestData,
        (data2) => {
          this.$message.success("绑定成功, 请耐心等待呼叫!");
        },
        (errormessage2) => {
          this.$message.error(errormessage2);
        },
      );
    }, 2000),
    handleClick(item, index, flag) {
      this.$emit("handleClick", item, index, flag);
    },
    changeShowPhoneFlag(item) {
      this.showPhoneFlag = !this.showPhoneFlag;
      this.showPhone(item);
    },
    // 帮我实现一个功能 点击小眼睛 把 item.phone 中间四位隐藏起来 显示 ****
    showPhone(item) {
      if (this.showPhoneFlag) {
        return item.phone;
      } else {
        return item.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      }
    },
    onCopy(item) {
      this.$emit("onCopy", item);
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.showContactsOrNot();
  },
};
</script>

<style lang="less" scoped>
#enterprise-card3 {
  width: 100%;
  .enterprise-card3-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .enterprise-card3-item {
      width: 32%;
      // min-height: 100px;
      margin-bottom: 10px;
      box-shadow: 0 0 8px #0000001a;
      border-radius: 4px;
      padding: 20px;
      margin: 5px;
      box-sizing: border-box;
      .title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .title-name {
          font-size: 18px;
          font-weight: 500;
          line-height: 18px;
          color: #111a34;
        }
        .title-position {
          margin: 0 4px 0 6px;
          font-size: 14px;
          line-height: 14px;
          color: #777e95;
        }
      }
      .phone {
        display: flex;
        align-items: center;
        width: 100%;
        margin-top: 5px;
        .phone-number {
          font-size: 15px;
          font-weight: 500;
          line-height: 18px;
          color: #111a34;
        }
        .active {
          flex: 1;
        }
        .icon {
          cursor: pointer;
          margin: 5px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
